import { createActionTypes, createNoLoadActionTypes } from './utils';

export const LOAD_CAMPAIGN_STATUS = createNoLoadActionTypes('LOAD_CAMPAIGN_STATUS');
export const UPDATE_CAMPAIGN_FIRST_POPUP = createActionTypes('UPDATE_CAMPAIGN_FIRST_POPUP');
export const UPDATE_CAMPAIGN_NOTNOW_POPUP = createActionTypes('UPDATE_CAMPAIGN_NOTNOW_POPUP');
export const UPDATE_CAMPAIGN_FEEDBACK_POPUP = createActionTypes('UPDATE_CAMPAIGN_FEEDBACK_POPUP');
export const SET_CAMPAIGN_DETAILS = createNoLoadActionTypes('SET_CAMPAIGN_DETAILS');
